import type { FlowMedia } from '@/types';
import { MAGIC_FLOW_WEBHOOK_URL } from '@/consts/urls';

import pollUntilCompleted from './pollUntilCompleted';
import buildFlowMediaFromPollResponse from './buildFlowMediaFromPollResponse';

const getMediaFromFlowId = async (id: string): Promise<FlowMedia | null> => {
  const pollUrl = `${MAGIC_FLOW_WEBHOOK_URL}/${id}/result`;

  const { response } = await pollUntilCompleted({ url: pollUrl });

  return buildFlowMediaFromPollResponse(id, response);
};

export default getMediaFromFlowId;
